import $ from 'jquery';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Sniffer from 'snifferjs';

gsap.registerPlugin(ScrollTrigger);

export default class Minicart {
    constructor(){   
        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu'),
        }

        this.search = {
            toggler: document.getElementById('search-toggler'),
            main: document.getElementById('search'),
        }

        this.user = {
            toggler: document.getElementById('user'),
        }
        
        this.minicart = {
            toggler: document.getElementById('cart'),
            main: document.getElementById('minicart'),
            products: document.querySelectorAll('#minicart .product-list .product'),
        }

        this.product = {
            ajax: document.querySelectorAll('.ajax_add_to_cart,.ajax_remove'),
        }

        this.header = document.querySelector('header');
        this.body = document.querySelector('body');
    }

    init(){
        this.toggle();
        if (this.product.ajax) { this.events(); };
    }

    toggle = () => {
        this.minicart.toggler.addEventListener('click', () => {
            this.header.classList.add('minicart-active');
            // If Mobile > <body> == overflow:hidden
            if(Sniff.features.mobile){
                if(this.body.classList.contains('overflow-hidden')){
                    this.body.classList.remove('overflow-hidden')
                } else {
                    this.body.classList.add('overflow-hidden')
                }
            }

            this.minicart.toggler.classList.toggle('active');
            this.minicart.main.classList.toggle('active');
            // Search De-activation
            this.search.toggler.classList.remove('active');
            this.search.main.classList.remove('active');
            // Menu De-activation
            this.menu.toggler.classList.remove('active');
            this.menu.main.classList.remove('active');
        });
    }

    events = () => {
        this.product.ajax.forEach(toggler => {
            toggler.addEventListener('click', (e) => {
                console.log('clicked')
                this.update()
                e.preventDefault();
            });
        })
    }

    update = () => {
        $.ajax({
            url: '/minicart',
            type: "GET",
            // data: {
            //   'action': 'mode_theme_update_mini_cart',
            // //   'post_id': post_id
            // }
          }).done(function(response) {
            $('#minicart').html(response); // Afficher le HTML

            // // Clean the Array
            var quantity = [];

            document.querySelectorAll('#minicart .product-list .product .quantity-price').forEach((product)=>{
                var product_quantity = Number(product.getAttribute('data-quantity'));
                quantity.push(product_quantity);
            });

            document.querySelector('#cart .notify').innerHTML = quantity.reduce((item, counter) => { counter = counter + item; return counter; }, 0);
          });
    }

    set = () => {
        // Set using GSAP
    }

    animation = () => {
        // Animate using GSAP
    }
}
